import axios from "axios";

const api = axios.create({
  baseURL: "https://api1-vapt-report.infosharesystems.io/vulnerability-assessments",
});

api.defaults.withCredentials = true;

const apiEndpoints = {
  login: `/login`,
  logout: `/logout`,
  me: `/me`,
  assessments: `/assessments`,
  assessment: (id) => `/assessments/${id}`,
  assessmentsByClientId: (clientId) => `/assessments/client/${clientId}`,
  assessmentVersionsByAssessmentId: (assessmentId) =>
    `/assessment-versions/by-assessment/${assessmentId}`,
  vulnerabilitiesByVersion: (assessmentId, assessmentVersionId) =>
    `/assessments/${assessmentId}/versions/${assessmentVersionId}/vulnerabilities`,
  vulnerabilities: `/vulnerabilities`,
  vulnerability: (vulnId) => `/vulnerabilities/${vulnId}`,
  workflowUpdate: `/workflow/update`,
  getTesters: "/users/testers",
  getTeamLeads: "/users/teamleads",
  getManagers: "/users/managers",
  getAssistantManagers: "/users/assistant-managers",

  getRetestInfo: (assessmentId) => `/assessments/${assessmentId}/retest-info`,
  submitRetestVersion: `/assessments/retest-version`,
};

export { api, apiEndpoints };
